 <div class="jh-popup">
   <div class="jh-popup-body">
     <mat-dialog-content class="mat-dialog-content">
       <!-- /row -->
       <div class="row mp-popup-header">
         <div class="col">
           <mat-progress-bar mode="indeterminate"></mat-progress-bar>
           <p id="ps-paragraph-2 mp-popup-mobile-txt">
             Please wait while your application responses are being processed.
           </p>
         </div>
       </div>
       <br>
       <div class="row text-muted">
         {{timerText}}
       </div>
     </mat-dialog-content>
   </div>
 </div>
